import {
    DEFAULT_OVERHEAD_PCT,
    DEFAULT_PROFIT_PCT,
    defaultSteepRoof,
    weightedMarginPct,
    type SteepRoofState,
    type FlatRoofState,
} from './roofState';

export function applySectionMargin(hardCost: number, overhead_pct: number, profit_pct: number) {
    const overhead = hardCost * overhead_pct;
    const profit = (hardCost + overhead) * profit_pct;
    return { overhead, profit };
}

/** Job-site and general "other" extras follow roof-weighted margin (not fixed defaults). */
export function marginForJobAndOther(
    steepRoofs: SteepRoofState[],
    flatRoofs: FlatRoofState[],
): { overhead_pct: number; profit_pct: number } {
    const all = [...steepRoofs, ...flatRoofs];
    if (all.length === 0) {
        return { overhead_pct: DEFAULT_OVERHEAD_PCT, profit_pct: DEFAULT_PROFIT_PCT };
    }
    return weightedMarginPct(all);
}

export function marginForRoofId(
    roofId: string | undefined,
    steepRoofs: SteepRoofState[],
    flatRoofs: FlatRoofState[],
) {
    const steep = steepRoofs.find(r => r.id === roofId);
    if (steep) return { overhead_pct: steep.overhead_pct, profit_pct: steep.profit_pct };
    const flat = flatRoofs.find(r => r.id === roofId);
    if (flat) return { overhead_pct: flat.overhead_pct, profit_pct: flat.profit_pct };
    return marginForJobAndOther(steepRoofs, flatRoofs);
}

// ponytail: self-check — zero P&O yields zero margin amounts.
const zeroPo = applySectionMargin(10_000, 0, 0);
if (zeroPo.overhead !== 0 || zeroPo.profit !== 0) {
    throw new Error('estimatorMargin self-check failed: zero P&O');
}
const jobMargin = marginForJobAndOther(
    [{ ...defaultSteepRoof(), overhead_pct: 0, profit_pct: 0, area: 0 }],
    [],
);
if (jobMargin.overhead_pct !== 0 || jobMargin.profit_pct !== 0) {
    throw new Error('estimatorMargin self-check failed: zero-area average');
}
